/** @format */
import { SearchFacet } from '@toucan/common/services/search/constants';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const ALLOWED_FACETS: string[] = [
    SearchFacet.productPrice,
    SearchFacet.productConditionStarRating,
    SearchFacet.productPriceModifier,
];
